<template>
    <div style="padding-bottom: 60px;" class="new-cell-group">
        <van-swipe :autoplay="3000" indicator-color="white" class="goods-detail-swipe">
            <van-swipe-item v-for="(item, index) in goodsDetail.images_info" :key="index">
                <van-image :src="item.url" style="display: block;" />
            </van-swipe-item>
        </van-swipe>
        <van-cell-group style="margin-top: 0.5rem;">
            <van-cell>
                <van-row class="goods-detail">
                    <van-row class="goods-detail-title">{{goodsDetail.title}}</van-row>
                    <van-row>
                        <div class="goods-detail-suit-site">
                            可兑换站点：
                            <van-tag type="primary" size="medium" style="margin-right: 10px; margin-bottom: 5px;" v-for="(suitSiteItem, suitSiteIndex) in goodsDetail.suit_site_info" :key="suitSiteIndex" @click="$router.push({ name : 'SiteDetail', query : { site_id : suitSiteItem.id } })">
                                {{suitSiteItem.name}}
                            </van-tag>
                        </div>
                    </van-row>
                    <van-row>
                        <van-col class="goods-detail-integral" :span="12">
							<div class="goods-inline" v-if="goodsDetail.integral > 0">{{goodsDetail.integral}}<span>积分</span></div>
							<div class="goods-inline" v-if="goodsDetail.integral > 0 && goodsDetail.amount > 0">+</div>
							<div class="goods-inline" v-if="goodsDetail.amount > 0">{{goodsDetail.amount}}<span>元</span></div>
                        </van-col>
                        <van-col class="goods-detail-stock" :span="12">
                            库存 {{goodsDetail.stock}}
                        </van-col>
                    </van-row>
                </van-row>
            </van-cell>

            <van-cell>
            </van-cell>
        </van-cell-group>
        <van-cell-group title="商品详情" class="title-describe">
            <van-cell>
                <div style="padding: 15px; word-break: break-word;">{{goodsDetail.describe}}</div>
                <div class="goods-detail-sku">
                    <van-button round class="goods-detail-sku-button" @click="skuShow = true">立即兑换</van-button>
                </div>
                
            </van-cell>
        </van-cell-group>
        

        <van-sku
            v-model="skuShow"
            :goods="goods"
            :goods-id="goodsDetail.id"
            :sku="sku"
            :hide-stock="false"
            :show-add-cart-btn="false"
            stepper-title="兑换数量"
            buy-text="确认"
            @buy-clicked="buyClick">
            <template slot="sku-header-price">
				<div>
					<div class="integral-text" v-if="this.goodsDetail.integral > 0">
						{{parseInt(this.goodsDetail.integral)}}<span>积分</span>
					</div>
					<div class="integral-text" v-if="this.goodsDetail.amount > 0 && this.goodsDetail.integral > 0">+</div>
					<div class="integral-text" v-if="this.goodsDetail.amount > 0">
						{{this.goodsDetail.amount}}<span>元</span>
					</div>
				</div>
            </template>

            <template #sku-actions="props">
                <div class="goods-detail-sku">
                    <van-button
                        round 
                        class="goods-detail-sku-button"
                        @click="props.skuEventBus.$emit('sku:buy')"
                    >
                        确认兑换
                    </van-button>
                </div>
            </template>
        </van-sku>
    </div>
</template>

<script>
    import api from "../../assets/js/api";

    export default {
        name: "Detail",
        data(){
            return {
                skuShow : false,
                goods: {
                    // 默认商品 sku 缩略图
                    picture: 'https://img.yzcdn.cn/vant/apple-1.jpg',
                },
                sku : {
                    tree:[],
                    stock_num: 49,
                    none_sku: true,
                },
                goodsDetail : {},
            };
        },
        created() {
            let self = this;
            api.request('/integral_goods/detail', {
                id : this.$route.query.id
            }).then(res => {
                self.goodsDetail = res.data;

                self.goods.picture = res.data['images_info'][0]['url'];
                self.sku.price = res.data['integral'];
                self.sku.stock_num = res.data['stock'];
            });
        },
        methods : {
            buyClick(skuData){
                this.$router.push({
                    name : 'IntegralGoodsCheckout',
                    query : {
                        goodsId : skuData.goodsId,
                        number : skuData.selectedNum,
                    },
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../style/base.scss';
    @import '../../style/themeify.scss';
    *{
        @include themeify{
			.goods-inline {
				display: inline;
			}

            .goods-detail-swipe {
                width: 100vw;
                height: 80vw;

                /deep/ .van-image {
                    height: 100%;
                    .van-image__img {
                        object-fit:cover;
                    }
                }

                /deep/ .van-swipe__indicators {
                    padding: 3px 6px;
                    border-radius: 6px;
                    background-color: #666;
                }
            }

            .goods-detail{
                background-color: #ffffff;

                .goods-detail-title{
                    font-size: 18px;
                    margin-bottom: 5px;
                }
                .goods-detail-integral{
                    color: themed('colorText');
                    font-size: 18px;
                    span{
                        font-size: 12px;
                        margin-left: 2px;
                    }
                }

                .goods-detail-suit-site {
                    width: 90%;
                    background-color: #ddd;
                    border-radius: 0.3rem;
                    color: #555;
                    font-weight: bold;
                    padding: 0.2rem;
                    margin:0.3rem 0;
                    .van-tag {
                        font-weight: lighter;
                        background-color: themed('colorTag');
                        border-radius: 0.2rem;
                    }
                }

                .goods-detail-stock{
                    text-align: right;
                    color: #888888;
                }
            }
            .integral-text{
                color: themed('colorText');
                font-size: 18px;
                span{
                    font-size: 12px;
                    margin-left: 2px;
                }
            }

            .goods-detail-sku {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 0.5rem;
            }

            .goods-detail-sku-button {
                color: #FFF;
                width: 80%;
                box-shadow: 0px 4px 6px rgba(255, 168, 9, 0.05);
                border-radius: 1rem;
                height: 1rem;
                background: linear-gradient(180deg, themed('colorGradientLeft') 0%, themed('colorGradientRight') 100%);
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/goods/Detail.vue